import { Card } from '@yleisradio/areena-types';
import { findLabel } from 'utils/card';

export const determineBroadcastStatus = (
  card: Card,
  currentTime = new Date()
) => {
  const now = currentTime.getTime();
  const start = new Date(
    findLabel(card.labels, 'broadcastStartDate')?.raw || ''
  ).getTime();
  const end = new Date(
    findLabel(card.labels, 'broadcastEndDate')?.raw || ''
  ).getTime();

  if (now > end) return 'expired';
  if (now < start) return 'upcoming';
  return 'current';
};

interface CardWithKey extends Card {
  key: string | number;
}

export function createSchedule(
  schedule: Card[],
  time = new Date()
): {
  expired: CardWithKey[];
  current: CardWithKey[];
  upcoming: CardWithKey[];
} {
  const cardsWithKeys = schedule.map<CardWithKey>((card, i) => ({
    ...card,
    key: i,
  }));

  const getByLabel = (label: 'expired' | 'current' | 'upcoming') =>
    cardsWithKeys.filter(
      (cardWithKey) => determineBroadcastStatus(cardWithKey, time) === label
    );

  return {
    expired: getByLabel('expired'),
    current: getByLabel('current'),
    upcoming: getByLabel('upcoming'),
  };
}
